import { render, staticRenderFns } from "./HandbookFilters.vue?vue&type=template&id=2695ba08&scoped=true&"
import script from "./HandbookFilters.vue?vue&type=script&lang=ts&"
export * from "./HandbookFilters.vue?vue&type=script&lang=ts&"
import style0 from "./HandbookFilters.vue?vue&type=style&index=0&id=2695ba08&lang=scss&scoped=true&"
import style1 from "./HandbookFilters.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2695ba08",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelHeader } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanels } from 'vuetify/lib/components/VExpansionPanel';
installComponents(component, {VExpansionPanel,VExpansionPanelContent,VExpansionPanelHeader,VExpansionPanels})
